import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

interface ProfileLinkField {
  label: string;
  placeholder: string;
  icon: string;
  value: string;
}

@Component({
  selector: 'app-profile-edit-modal',
  templateUrl: './profile-edit-modal.component.html',
  styleUrls: ['./profile-edit-modal.component.scss'],
})
export class ProfileEditModalComponent implements OnInit {
  @Input() profile: any;

  description = '';
  publicCity = '';
  publicCountryCode = '';
  publicLocationEnabled = false;
  saving = false;
  readonly linkFields: ProfileLinkField[] = [
    { label: 'Página web', placeholder: 'https://tu-sitio.com', icon: 'globe-outline', value: '' },
    { label: 'Aplicación App Store', placeholder: 'Enlace de App Store', icon: 'logo-apple-appstore', value: '' },
    { label: 'Aplicación Play Store', placeholder: 'Enlace de Play Store', icon: 'logo-google-playstore', value: '' },
    { label: 'Facebook', placeholder: 'Enlace de Facebook', icon: 'logo-facebook', value: '' },
    { label: 'Instagram', placeholder: 'Enlace de Instagram', icon: 'logo-instagram', value: '' },
    { label: 'Snapchat', placeholder: 'Enlace de Snapchat', icon: 'logo-snapchat', value: '' },
    { label: 'TikTok', placeholder: 'Enlace de TikTok', icon: 'logo-tiktok', value: '' },
    { label: 'Twitch', placeholder: 'Enlace de Twitch', icon: 'logo-twitch', value: '' },
    { label: 'X / Twitter', placeholder: 'Enlace de X', icon: 'logo-twitter', value: '' },
    { label: 'YouTube', placeholder: 'Enlace del canal', icon: 'logo-youtube', value: '' },
    { label: 'WhatsApp', placeholder: 'Enlace de WhatsApp', icon: 'logo-whatsapp', value: '' },
    { label: 'Reddit', placeholder: 'Enlace de Reddit', icon: 'logo-reddit', value: '' },
    { label: 'WeChat', placeholder: 'Enlace de WeChat', icon: 'chatbubble-ellipses-outline', value: '' },
  ];

  constructor(private modalController: ModalController) {}

  ngOnInit(): void {
    this.description = String(this.profile?.description ?? '');
    this.publicCity = String(this.profile?.public_city ?? '');
    this.publicCountryCode = String(this.profile?.public_country_code ?? '').toUpperCase();
    this.publicLocationEnabled = Boolean(this.profile?.public_location_enabled);
    const links = this.parseLinks(this.profile?.WebPage);
    this.linkFields.forEach((field, index) => {
      field.value = String(links[index] ?? '');
    });
  }

  close(): void {
    void this.modalController.dismiss();
  }

  save(): void {
    if (this.saving) return;
    this.saving = true;
    void this.modalController.dismiss({
      description: this.description.trim(),
      webPages: this.linkFields.map(field => field.value.trim()),
      publicCity: this.publicCity.trim(),
      publicCountryCode: this.publicCountryCode.trim().toUpperCase(),
      publicLocationEnabled: this.publicLocationEnabled,
    }, 'save');
  }

  private parseLinks(value: any): any[] {
    if (Array.isArray(value)) return value;
    if (typeof value !== 'string' || !value.trim()) return [];
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [value];
    }
  }
}
